// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3AskA","empty":"ModalGraph_empty__2qe1c"};